import React from "react";
import { Flex } from "styles/utility-components";

import Button from "components/ui/button/Button";
import { EventNames, useTracking } from "lib/tracking";

/**
 * Header which is used for external users that aren't logged in
 * @returns
 */
export function BidModuleCustomHeader(): JSX.Element {
  const { logEvent } = useTracking();
  return (
    <Flex alignItems="center" gap={20}>
      <Button buttonType="tertiary" as="a" href="/users/sign_in">
        Log in
      </Button>

      <Button
        as="a"
        href="/get-started"
        onClick={() => {
          logEvent(EventNames.clickedSignUpCTA, {
            "Context source": "Scorecard Screen",
          });
        }}
      >
        Free sign up
      </Button>
    </Flex>
  );
}
